import React, { useState, useEffect, useMemo, useRef } from 'react';
import { NavLink, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import './Projects.less';
import ProjectCard from '../components/ProjectCard';
import api from '../api';
import Page from '../components/_layout/Page';
import { useStore } from '../stores/StoreHelpers';
import { sortByAlphaNum } from '../helpers/table';
import { getPathType, getTypeProject, getSectionLinkPart } from '../helpers/typeProject'

export default function Projects(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [projects, setProjects] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const location = useLocation();

  const sectionLinkPart = useMemo(() => getSectionLinkPart(location.pathname), [location.pathname]);
  const typeProject = useMemo(() => getTypeProject(sectionLinkPart), [sectionLinkPart]);

  useEffect(async () => {
    try {
      const result = await api.get(`/mng/strategies?type=${typeProject}`);
      if (typeProject === 'tech') {
        const candidatesData = await api.get('/portfolios/candidates');
        setCandidates(candidatesData);
      } else {
        setCandidates([]);
      }
      setIsLoaded(true);
      setProjects(result);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  }, [sectionLinkPart]);

  const projectsByType = useMemo(() => {
    const sortProjects = (projects) => {
      return projects.sort((a, b) => sortByAlphaNum(a.num, b.num));
    };

    const sortedProjects = projects.reduce((acc, curr) => {
      const type = curr.isArchived ? 'archived' : 'active';
      return {...acc, [type]: [...acc[type], curr]};
    }, {archived: [], active: []});

    return {
      archived: sortProjects(sortedProjects.archived),
      active: sortProjects(sortedProjects.active)
    };
  }, [projects]);

  const headerTitle = {
    strats: 'Стратегические проекты (архив до 2024)',
    policies: 'Политики',
    archive: 'Политики (архив до 2024)',
    goals: 'Стратегические цели университета',
    techs: 'Стратегические технологические проекты',
  }[sectionLinkPart];

  const archivedTitle = {
    strats: 'Недействующие стратегические проекты',
    goals: 'Недействующие стратегические цели университета',
    techs: 'Недействующие стратегические технологические проекты',
  }[sectionLinkPart];

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page projects-page"><div className="container"><div>Загрузка...</div></div></section>;
  }
  return (
    <Page header={headerTitle} className="projects-page">
        {sectionLinkPart !== 'archive' && <div>
          <StratProjectsList projects={projectsByType.active}/>
        </div>}
        {sectionLinkPart !== 'policies' && projectsByType.archived.length > 0 && <div className='mt-3'>
          <h2>{archivedTitle}</h2>
          <StratProjectsList projects={projectsByType.archived}/>
        </div>}
        {sectionLinkPart === 'techs' && candidates.length > 0 && (
          <div className='mt-3'>
            <h2>Кандидаты в стратегические технологические проекты</h2>
            <StratProjectsList projects={candidates}/>
          </div>
        )}
    </Page>
  );
}

const StratProjectsList = ({projects}) => {
  const { url } = useRouteMatch();
  const store = useStore();
  const wrapperRef = useRef();
  const [maxHeight, setMaxHeight] = useState();

  useEffect(() => {
    if (!wrapperRef.current) return;
    const cardsHeadings = Array.from(wrapperRef.current.querySelectorAll(".project-card-heading"))
    const maxHeight = Math.max(...cardsHeadings.map(x => x.offsetHeight))
    setMaxHeight(maxHeight);
  }, [wrapperRef.current])
  

  return (
      <ul className="wrapper" ref={wrapperRef}>
        {projects.map((project, i) => (
          <li key={i}>
            {project.type === 'candidate' ? (
              <NavLink to={`/${getPathType(project.strategy.type)}/${project.strategy.id}/portfolios/${project.id}`}>
                <ProjectCard onClick={() => store.strategies.clearStore()} data={project} minHeaderHeight={maxHeight} />
              </NavLink>
            ) : (
              <NavLink to={`${url}/${project.id}`}>
                <ProjectCard onClick={() => store.strategies.clearStore()} data={project} minHeaderHeight={maxHeight} />
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    )
}